<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<agency-project-evaluations-filters
			v-model="dataTable.search"
			:evaluation-type="'agency-final'"
			:is-project="true"
		/>
		<v-data-table
			:headers="dataTable.headers"
			:rows-per-page-items="[10,20,25]"
			:loading="loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td>{{props.item.agencyProjectCode}}</td>
				<td>{{props.item.agencyProjectTitle}}</td>
				<td>{{props.item.contestName}}</td>
				<td>{{props.item.status}}
					<span class="ml-1" v-if="props.item.status === 'Do poprawek'">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-icon size="18" color="blue" dark v-on="on">mail_outline</v-icon>
							</template>
							<div>
								<div>
									<b>{{ props.item.correctionCause }}</b>
								</div>
								{{ props.item.detailedCorrectionCause }}
							</div>
						</v-tooltip>
					</span>
				</td>
				<td>
					<v-icon
						@click="startEvaluation(props.item)"
						v-if="props.item.status === 'Nierozpoczęta'"
						title="Rozpocznij"
					>add_box
					</v-icon>
					<v-icon
						@click="editEvaluation(props.item)"
						v-if="props.item.status === 'Rozpoczęta' || props.item.status === 'Do poprawek'"
						title="Edytuj"
					>edit
					</v-icon>
					<v-icon
						@click="viewEvaluation(props.item)"
						v-if="props.item.status === 'Zakończona'"
						title="Szczegóły"
					>description
					</v-icon>
					<v-icon
						@click="sendInappropriateAssignmentNotification(props.item)"
						v-if="props.item.status === 'Nierozpoczęta' || props.item.status === 'Rozpoczęta' || props.item.status === 'Do poprawek'"
						title="Zgłoś błąd"
					>error
					</v-icon>
				</td>
			</template>
		</v-data-table>
		<inappropriate-assignment-notification-confirmation
			v-if="inappropriateAssignmentDialog"
			v-bind:evaluation="evaluation"
			v-bind:evaluation-type="'AGENCY_FINAL_EVALUATION'"
			v-on:close-dialog="closeDialog()"
			v-on:sent-inappropriate-assignment="inappropriateAssignment()"/>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {AgencyFinalEvaluation} from "@/api/generated/AgencyFinalEvaluation";
	import InappropriateAssignmentNotificationConfirmation from "../../InappropriateAssignmentNotificationConfirmation";
	import AgencyProjectEvaluationsFilters from "../../../agencyProject/AgencyProjectEvaluationsFilters";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AgencyProjectFinalEvaluationTable",

		components: {AgencyProjectEvaluationsFilters, InappropriateAssignmentNotificationConfirmation},

    mixins: [Filters],

		data () {
			return {
				dataTable: {
					search: "",
					headers: [
						{text: "Numer wniosku", value: "agencyProjectCode", sortable: true},
						{text: "Nazwa projektu", value: "projectName", sortable: true},
						{text: "Nabór", value: "agencyContestName", sortable: true},
						{text: "Status", value: "status", sortable: true},
						{text: "Akcje", sortable: false},
					],
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
				},
				loading: false,
				inappropriateAssignmentDialog: false,
				evaluation: {}
			};
		},

		methods: {
			inappropriateAssignment() {
				this.closeDialog();
				this.evaluation.status = "Niewłaściwie przypisana";
			},

			closeDialog () {
				this.inappropriateAssignmentDialog = false;
			},

			getItemList () {
				let sort = this.buildSort();
				Api.get(this, "/agency-final-evaluation/list?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page
					+ "&result=" + this.dataTable.pagination.rowsPerPage
					+ "&sort=".concat(sort), response => {
					this.dataTable.itemList = response.itemList;
					this.dataTable.itemCount = response.itemCount;
				});
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			startEvaluation (item) {
				AgencyFinalEvaluation.put(this, item.id, () => {
					this.$router.push("/app/agency-contest/".concat(item.contestId).concat("/final-evaluation/").concat(item.id));
				});
			},

			editEvaluation (item) {
				this.$router.push("/app/agency-contest/".concat(item.contestId).concat("/final-evaluation/").concat(item.id));
			},

			viewEvaluation (item) {
				this.$router.push("/app/agency-contest/".concat(item.contestId).concat("/final-evaluation/").concat(item.id));
			},

			sendInappropriateAssignmentNotification (item) {
				this.evaluation = item;
				this.inappropriateAssignmentDialog = true;
			}
		},

    mounted() {
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
    },

		watch: {
			"dataTable.search": {
				handler() {
					this.getItemList();
				},
			},

			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},
		}
	};
</script>

<style scoped>

</style>
